var push_report_chart = function()
{
	var instance = {};

	//Set scope variable to init dbtable with options, columns etc
	instance.init = function(scope, componentKey, component)
	{
		//initalise component properties
		scope[componentKey] = {};
		scope[componentKey].instance = {};
		scope[componentKey].data = component.init_config;
	};
	instance.update = function(scope, componentKey, resultComponentVal)
	{
		var config_data = scope[componentKey].data;

		//extend the component config with the result data
		$.extend( true, config_data, resultComponentVal.config );
		resultComponentVal.config = config_data;

		//reset component properties
		scope[componentKey] = {};
		scope[componentKey].instance = {};

		var positioner = function (labelWidth, labelHeight, point) {
				var height = this.chart.chartHeight-point.plotY+labelHeight+22 > this.chart.chartHeight? (point.plotY+22) : (point.plotY-labelHeight-8);
				var width = (this.chart.chartWidth / 2) - (labelWidth / 2);
				return {
					x: width,
					y: height
				};
			};

		var dataLabelsObj = {
			"crop": false,
			"enabled":true,
			"overflow": "none",
			"color": "#000000",
			"useHTML": true,
			"formatter": function(){
				var null_data_display = this.point.null_data_display;
				var display_sign = '';
				var css_class = (this.y < 0) ? "datalabel datalabel-negative" : "datalabel";
				if(typeof resultComponentVal.config.series[0].display_sign != 'undefined')
				{
					display_sign = resultComponentVal.config.series[0].display_sign;
				}

				if (typeof null_data_display === 'string' || null_data_display instanceof String)
				{
					return '<span class="datalabel">'+null_data_display+'</span>';
				} else {
					return (null_data_display === 0) ? null_data_display : '<span class="'+css_class+'">'+Highcharts.numberFormat(null_data_display,1)+display_sign+'</span>';
				}
			}
		};

		var yAxisLabel =  {
			"formatter": function(){
				var display_sign = '';
				if(typeof resultComponentVal.config.series[0].display_sign != 'undefined')
				{
					display_sign = resultComponentVal.config.series[0].display_sign;
				}
				if(this.value == 0)
				{
					return '<b>'+this.value+'</b>';
				}

				return this.value+display_sign;
			}
		}

		if( typeof resultComponentVal.config.options.plotOptions.column.dataLabels != 'undefined' &&
			typeof resultComponentVal.config.options.plotOptions.column.dataLabels.enabled != 'undefined' &&
			resultComponentVal.config.options.plotOptions.column.dataLabels.enabled != false )
		{
			resultComponentVal.config.options.plotOptions.column.dataLabels = dataLabelsObj;
		}

		if( typeof resultComponentVal.config.options.yAxis.labels != 'undefined')
		{
			resultComponentVal.config.options.yAxis.labels = yAxisLabel;
		} else if( typeof resultComponentVal.config.options.yAxis[0].labels != 'undefined')
		{
			resultComponentVal.config.options.yAxis[0].labels = yAxisLabel;
		}


		resultComponentVal.config.options.chart.events = {
			load:function () {
				//Add benchmark_score_block
				if( typeof resultComponentVal.config.options.benchmark_score_block != 'undefined')
				{
					var offsetWidth = 0;

	                var benchmark_score = resultComponentVal.config.options.benchmark_score_block.benchmark_display_value;
	                var display_sign = resultComponentVal.config.options.benchmark_score_block.display_sign;
					
					benchmark_score += !isNaN(parseFloat(benchmark_score)) && isFinite(benchmark_score) && benchmark_score !== 0?display_sign:'';
					
	                this.chart_width = this.plotLeft + this.plotWidth + 16 - offsetWidth;
					this.myCompareBox = this.renderer.html('<div style="text-align: center;background:#5EB6E4;color:#fff;padding:8px 4px;border: 1px solid #378fbd;font-family:Verdana,sans-serif;">'+
					'<span align="center" style="display: block;font-size:12px;font-weight:bold;">Dealer CSI R6M</span>'+
					'<span align="center" style="display: block;color: #fff; font-size: 21px; margin: 4px 0 0 0; padding: 0px;">'+benchmark_score+'</span>'+
					'</div>', this.chart_width, 60)
				    .css({
				      color: '#999999',
				      fontSize: '13px'

				    })
				    .add();
				}
				
            },
			redraw:function (){
				//Add benchmark_score_block
				if( typeof resultComponentVal.config.options.benchmark_score_block != 'undefined')
				{
					var offsetWidth = 0;
					
					var benchmark_score = resultComponentVal.config.options.benchmark_score_block.benchmark_display_value;
	                var display_sign = resultComponentVal.config.options.benchmark_score_block.display_sign;
					
					benchmark_score += !isNaN(parseFloat(benchmark_score)) && isFinite(benchmark_score) && benchmark_score !== 0?display_sign:'';
					
					if(this.myCompareBox){
						this.myCompareBox.destroy();
					}
					this.chart_width = this.plotLeft + this.plotWidth + 16 - offsetWidth;
					// alert(this.chart_width);
					
					this.myCompareBox = this.renderer.html('<div style="text-align: center;background:#5EB6E4;color:#fff;padding:8px 4px;border: 1px solid #378fbd;font-family: Verdana,sans-serif;">'+
					'<span align="center" style="display: block;font-size:12px;font-weight:bold;">Dealer CSI R6M</span>'+
					'<span align="center" style="display: block;color: #fff; font-size: 21px; margin:  4px 0 0 0; padding: 0px;">'+benchmark_score+'</span>'+
					'</div>', this.chart_width, 60)
					.css({
					  color: '#999999',
					  fontSize: '13px'

					})
					.add();
				}

			}
		};
		//update component
		scope[componentKey].data = resultComponentVal.config;
	};

	return instance;
};
